export { default } from './CardMedia';